<!--<section class="app-outlet">
  <app-header *ngIf="isSuperAdmin && isLoggedin"></app-header> 
  <app-pos-header *ngIf="(isLoggedin && isManager && !isWaitersGeneralRoute)"></app-pos-header>
  <app-waiter-header *ngIf="(isLoggedin && !isManager && !isWaitersGeneralRoute)"></app-waiter-header>
  <main class="h-100">
    <div class="h-100 d-flex">
       <app-navbar *ngIf="isSuperAdmin && isLoggedin"></app-navbar> 
      <app-pos-navbar *ngIf="isLoggedin && isManager && !isWaitersGeneralRoute"></app-pos-navbar>
      <div class="w-100" [ngClass]="[(isLoggedin) ? 'div_router_outlet'  : '', (isLoggedin && !isManager)? 'div_router_outlet_waiter'  : '', ]">
        <router-outlet>
        </router-outlet>
      </div>
    </div>
  </main>
   <app-footer></app-footer> 
</section>
<p-toast position="bottom-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-toast>
-->

<section *ngIf="isLoggedin && (isAdmin || isManager)" class="pos-layout">
  <app-pos-navbar *ngIf="!isWaitersGeneralRoute"></app-pos-navbar>
  <div class="pos-col-2 w-100">
    <app-pos-header *ngIf="!isWaitersGeneralRoute"></app-pos-header>
    <div class="pos-main-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</section>

<section *ngIf="isLoggedin && !(isAdmin || isManager)" class="w-100 h-100">
  <app-waiter-header *ngIf="!isWaitersGeneralRoute"></app-waiter-header>
  <div class="h-100 div_router_outlet_waiter">
    <router-outlet></router-outlet>
  </div>
</section>

<section *ngIf="!isLoggedin" class="w-100 h-100">
  <router-outlet></router-outlet>
</section>